import { useId, useState } from 'react';
import { Button, Text } from 'react-aria-components';
import { Trans, useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faWarning } from '@fortawesome/free-solid-svg-icons';
import styles from './styles.module.scss';

export const UpcomingMaintenance = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const id = useId();

  if (!isVisible) return null;

  return (
    <div className={styles.container} role="region" aria-labelledby={id}>
      <div className={styles.content}>
        <section className={styles.wrapper}>
          <div className={styles.noticeContentWrapper}>
            <FontAwesomeIcon icon={faWarning} className={styles.icon} />
            <div className={styles.textWrapper}>
              <h2 id={id} className={styles.title}>
                <Trans i18nKey="maintenance.maintenanceNotice" />
              </h2>
              <Text>
                <Trans i18nKey="maintenance.maintenanceMessage" />
              </Text>
            </div>
          </div>
          <Button
            aria-label={t('consults.close')}
            className={styles.closeButton}
            onClick={() => setIsVisible(false)}
          >
            <FontAwesomeIcon
              icon={faClose}
              className={styles.closeIcon}
              aria-hidden
            />
          </Button>
        </section>
      </div>
    </div>
  );
};
